import { render } from "./IPdfPreview.vue?vue&type=template&id=125dbba6&scoped=true&ts=true"
import script from "./IPdfPreview.vue?vue&type=script&lang=ts"
export * from "./IPdfPreview.vue?vue&type=script&lang=ts"

import "./IPdfPreview.vue?vue&type=style&index=0&id=125dbba6&lang=css&scoped=true"

import exportComponent from "/root/.jenkins/workspace/SuperLink-华为云生产环境/SuperLink-Manager-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125dbba6"]])

export default __exports__